<ul class="progress-bullets">
	<li *ngFor="let bullet of bullets">
		<a
			[class.clickable]="bullet.clickable"
			[class.complete]="bullet.state === 'complete'"
			[class.current]="bullet.state === 'current'"
			(click)="bullet.clickable && bullet.onClick()"
		>
			<i class="fas fa-check"></i>
		</a>
	</li>
	<li class="progress-line" [style.width]="progress_percentage + '%'"></li>
</ul>
